import React from "react";
import { AnimatedBackground } from "./AnimatedBackground";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative isolate pt-32 md:pt-44 pb-14 md:pb-20 overflow-hidden"
    >
      <AnimatedBackground variant="hero" />

      <div className="relative mx-auto max-w-4xl px-6 md:px-10 text-center">
        <div
          className="inline-flex items-center gap-3 reveal"
          data-testid="hero-eyebrow"
        >
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
          <span
            className="font-mono-label section-eyebrow home-eyebrow"
            style={{ color: "#E8C97A", letterSpacing: "0.12em" }}
          >
            Autopilot Your Income
          </span>
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
        </div>

        <h1
          className="font-display hero-headline mt-5 leading-[1.02] reveal"
          style={{
            animationDelay: "0.1s",
          }}
          data-testid="hero-heading"
        >
          <span className="block whitespace-nowrap">EVERYONE Needs</span>
          <span className="hero-wordmark-line block whitespace-nowrap" aria-label="Trading Bots">
            <span className="wordmark hero-wordmark-paint" aria-hidden="true">Trading Bots</span>
          </span>
        </h1>

        <div
          className="mt-7 max-w-3xl mx-auto space-y-4 text-white/90 leading-relaxed reveal"
          style={{
            animationDelay: "0.2s",
            fontSize: "clamp(1.05rem, 1.333vw, 1.2rem)",
          }}
        >
          <p className="editorial-justify" data-testid="hero-body-1">
            Trading bots are software programs designed to read different
            financial markets and execute trades. They were developed by banks
            decades ago to replace their professional traders, allowing them to
            drastically minimize losses and create predictable profits.
          </p>
          <p className="editorial-justify" data-testid="hero-body-2">
            Until recently, these &lsquo;Digital Employees&rsquo; were reserved
            for the financial industry, accredited investors and a select group
            of well informed people. Thanks to the emergence of blockchain
            technology, that&rsquo;s no longer the case.
          </p>
        </div>
      </div>
    </section>
  );
};
